module.exports = __webpack_public_path__ + "img/empty-watch-list.5b23dc0c.svg";